module.exports =
{

  _init: function ()
  {
    this.onAccept()
    this.onContinue()
    if (window.location.href.indexOf("dashboard") == -1) {
      APPLICATION.PodConfigurator.modals.createPopup.setupModal("terms")
    }
    else{
      APPLICATION.PodConfigurator.modals.createPopup.setupModal("terms2")
      this.onBack()
    }
  },
  
  onContinue: function ()
  {
    Array.from(document.querySelectorAll('#pod-continue:not(.js-ignore)')).forEach((ele)=>{
      ele.classList.add('js-ignore')
      ele.addEventListener("click", () => {
        if(window.location.href.indexOf("dashboard") == -1){
          $('#pod-form').submit()
        }
        else{
          APPLICATION.PodConfigurator.modals.createPopup.resetModal()
          APPLICATION._APPLICATION.customModal(
              "/pod-configurator/send-email",
              "PodConfigurator",
              "sendEmail"
          );
        }
      })
    })

      


  },
  onBack: function() 
  {
    $('.modal-back-button').click(function(){
      APPLICATION.PodConfigurator.modals.createPopup.resetModal()
          APPLICATION._APPLICATION.customModal(
              "/buy-pods?modal=1",
              "Home",
              "buyPods"
          );
    })
  },

  onAccept: function() 
  {
    Array.from(document.querySelectorAll('#accept:not(.js-ignore)')).forEach((ele)=>{
      ele.classList.add('js-ignore')
      ele.addEventListener("change", () => {
        Array.from(document.querySelectorAll('#pod-continue')).forEach((ele2)=>{
          $(ele2).attr("disabled",!$(ele).is(":checked"))
        })
        
      })
    })
    
  }

}